'use client';

import { Draggable } from '@hello-pangea/dnd';
import { Partner, CATEGORY_LABELS, Priority } from '@/types';

const PRIORITY_STYLE: Record<Priority, { dot: string; label: string }> = {
  high: { dot: 'bg-red-500', label: 'Alta' },
  medium: { dot: 'bg-amber-500', label: 'Media' },
  low: { dot: 'bg-gray-400', label: 'Baja' },
};

const FLAG: Record<string, string> = {
  'México': '🇲🇽',
  'Perú': '🇵🇪',
  'Colombia': '🇨🇴',
};

export default function PartnerCard({
  partner,
  index,
  onClick,
}: {
  partner: Partner;
  index: number;
  onClick: () => void;
}) {
  const cat = CATEGORY_LABELS[partner.category];
  const prio = partner.priority ? PRIORITY_STYLE[partner.priority] : null;
  const dmCount = partner.decision_makers?.length || 0;

  return (
    <Draggable draggableId={partner.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={onClick}
          className={`bg-white rounded-lg border p-3 mb-2 cursor-pointer transition-shadow ${
            snapshot.isDragging ? 'shadow-lg border-[#0890F1]' : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
          }`}
        >
          <div className="flex items-start justify-between gap-2">
            <span className="font-medium text-sm text-gray-900 leading-tight">{partner.partner}</span>
            {prio && (
              <span className="flex items-center gap-1 flex-shrink-0" title={`Prioridad ${prio.label}`}>
                <span className={`w-2 h-2 rounded-full ${prio.dot}`} />
              </span>
            )}
          </div>
          <div className="flex items-center gap-1.5 mt-2 text-xs text-gray-500 flex-wrap">
            <span title={cat?.label}>{cat?.emoji} {cat?.label || partner.category}</span>
            {partner.country && <span>· {FLAG[partner.country] || ''} {partner.country}</span>}
          </div>
          {(partner.next_action || dmCount > 0) && (
            <div className="flex items-center gap-2 mt-2 text-xs">
              {partner.next_action && (
                <span className="text-[#0770C5] truncate flex-1" title={partner.next_action}>
                  → {partner.next_action}
                </span>
              )}
              {dmCount > 0 && (
                <span className="text-gray-400 flex-shrink-0" title={`${dmCount} contacto(s)`}>👤 {dmCount}</span>
              )}
            </div>
          )}
        </div>
      )}
    </Draggable>
  );
}
